
import React from 'react';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppUserContext } from '../../App';
import Nav from '../../components/breadcrumb';
import { ErrorLoading } from '../../components/loading';
import ExpenseForm from './expense-form';

const expense = {
    category: '',
    expense_date: '',
    title: '',
    isItemized: false,
    description: '',
    account_id: '',
    feenote_id: '',
    isBillable: false,
    isTaxInclusive: true,
    amount: '',
    receipt_file_id: '',
    tax_percent: 0,
    payment_method: "",
    client_id: "", 
    markup: "",
    user_reference: "", 
    vendor: "",
    items: [],
    isBill: false,
    due_date: "",
    method: "",
    account: ""
}

const NewExpense = () => {

    const nav_items = [
        { title: 'Expenses', href: '/app/expenses' },
        { title: 'New Expense' }
    ];

    const navigate = useNavigate();

    const handleSubmit = (details) => {
        navigate(`/app/expenses/${details.id}`);
    }

    const { profile } = useContext(AppUserContext);

    if (profile.permission_level !== 1) {
        return <ErrorLoading>You do not have the permission to create expenses. You might have permission to create staff payments, requisitions or payroll.</ErrorLoading>
    }

    return (
        <>
            <Nav items={nav_items} />

            <ExpenseForm
                details={expense}
                action="create"
                onSubmit={handleSubmit}
            />
        </>
    )
}


/**
 * 
 * @param {Object} props
 * @param {import('../../resources/api/expenses').ExpenseObject} props.details 
 * @param {React.Dispatch<React.SetStateAction<import('../../resources/api/expenses').ExpenseObject>>} props.setDetails 
 */
const EditExpense = ({ details, setDetails }) => {

    const nav_items = [
        { title: 'Expenses', href: '/app/expenses' },
        { title: details.reference, href: `/app/expenses/${details.id}` },
        { title: 'Edit Details' }
    ];

    const navigate = useNavigate();

    const handleSubmit = (details) => {
        setDetails(d => ({ ...d, ...details }));
        navigate(`/app/expenses/${details.id}`);
    }

    const { profile } = useContext(AppUserContext);

    if (profile.permission_level !== 1) {
        return <ErrorLoading>You do not have the permission to edit expenses.</ErrorLoading>
    }


    return (

        <>
            <Nav items={nav_items} />

            <div className="max-800 p-2">
                <ExpenseForm
                    details={details}
                    onSubmit={handleSubmit}
                    action="edit"
                />
            </div>
        </>
    )

}


export { EditExpense };


export default NewExpense;